<script setup>
import HeaderMain from '@/components/HeaderMain.vue'
import HeaderUnauth from '@/components/HeaderUnauth.vue'
import Footer from '@/components/Footer.vue'
import FooterUnauth from '@/components/FooterUnauth.vue'
import Five9ChatWidget from '@/components/Five9ChatWidget.vue'
import TimeoutModal from '@/components/TimeoutModal.vue'
import SystemMessageBanner from '@/components/SystemMessageBanner.vue'
import LogRocket from '@/components/LogRocket.vue'
import { computed } from 'vue'

if (import.meta.env.VITE_DYNATRACE_PATH) {
	const script = document.createElement('script')
	script.src = encodeURI(import.meta.env.VITE_DYNATRACE_PATH)
	script.crossOrigin = 'anonymous'
	document.head.appendChild(script)
}
const hasFiveNine = computed(() => import.meta.env.VITE_FIVENINE_SCRIPT)
</script>

<template>
	<v-app>
		<SystemMessageBanner />
		<HeaderMain v-if="!$route.meta.hideNavigation" />
		<HeaderUnauth v-else-if="$route.meta.showBasicTemplate && !$route.meta.hideHeader" />
		<div class="content-wrapper">
			<RouterView class="h-100" />
		</div>
		<ErrorModal />
		<LoadingSpinnerTakeover />
		<Footer v-if="!$route.meta.hideFooter" />
		<FooterUnauth v-else-if="$route.meta.showBasicTemplate" />
		<TimeoutModal />
		<Five9ChatWidget v-if="!$route.meta.hideUntilPlanSelected && hasFiveNine" />
		<LogRocket v-if="!$route.meta.hideUntilPlanSelected" />
	</v-app>
</template>

<style lang="scss">
.content-wrapper {
	flex-grow: 1;
}

.link,
.link:visited,
.link:active {
	color: $text-brand;
	cursor: pointer;

	&:hover,
	&:focus {
		color: $neutral-900;
	}

	&--underline {
		text-decoration: underline;
	}
}

.icon-btn {
	.v-btn__content {
		@media (max-width: 600px) {
			clip: rect(0 0 0 0);
			clip-path: inset(50%);
			height: 1px;
			overflow: hidden;
			position: absolute;
			white-space: nowrap;
			width: 1px;
		}
	}

	.v-btn__append {
		@media (max-width: 600px) {
			margin-inline-start: 0;
		}

		@media (min-width: 601px) {
			display: none;
		}
	}
}

form.inline-form {
	display: flex;
	align-items: stretch;

	.v-text-field {
		max-width: 100%;
		flex: 0 1 320px;

		.v-field {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
	}

	.v-input__control {
		--v-input-control-height: 44px;
	}

	.v-btn {
		height: auto;

		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
}

#five9OpenChatButton,
#five9LiveChatWidget {
	@media print {
		display: none !important;
	}
}
</style>
